import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { MenuManagementBrandItem } from '@/pages/menu-managements/items/service';
import { MenuManagementBrandItemService } from '@/services/BrandItem/MenuManagementItemService';
import { MenuManagementListQueryParams } from '@/services/Service/MenuManagementList';

export type MenuManagementBrandItemListParams = MenuManagementListQueryParams;

export type SearchBrandItemListResponse = {
  brand_items: MenuManagementBrandItem[];
  count: number;
};

export const useMenuManagementListBrandItems = async (
  params: MenuManagementBrandItemListParams
): Promise<SearchBrandItemListResponse> => {
  const menuManagementBrandItemService = new MenuManagementBrandItemService(
    getClient()
  );
  try {
    const res = await menuManagementBrandItemService.list(params);
    return res;
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
